import { ListAssessmentsSortDirection, ListAssessmentsSortField, FileExistenceStatus } from '../../../../serviceworker/src/bridges/assessmentPackageManagerMessages';
import { AssessmentPackageMetadata } from '../../../../serviceworker/src/models/AssessmentPackageMetadata';
/**
 * Interface for managing assessment packages.
 */
export interface IAssessmentPackageManagerClient {
    /**
     * Checks if an assessment package exists based on its metadata.
     * @param filename - The name of the assessment package file
     * @param env - The environment identifier
     * @param package_type - The type of assessment package
     * @param assessment_uuid - The unique identifier of the assessment
     * @param valid_from - The start date of validity
     * @param valid_to - The end date of validity 
     * @param school_code - The school code, if applicable
     * @returns A promise that resolves to a FileExistenceStatus indicating the existence state of the assessment package
     */
    checkFileExistence(filename: string, env: string, package_type:string, assessment_uuid: string, valid_from: string, valid_to: string, school_code: number | null): Promise<FileExistenceStatus>;

    /**
     * Feeds a downloaded file into the store along with its metadata.
     * @param file - The downloaded file.
     * @param metadata - The metadata associated with the file.
     * @returns A promise that resolves to the assessment ID.
     */
    feedDownloadedFile(file: File, metadata: any): Promise<number>;

    /**
     * Lists the assessments loaded, sorted by specified fields.
     * @param sortFields - An array of objects specifying the fields to sort by and the direction.
     * @returns A promise that resolves to an array of assessments.
     */
    listAssessments(sortFields: ListAssessmentsSortField[]): Promise<AssessmentPackageMetadata[]>;

    /**
     * Loads an assessment based on its ID.
     * @param assessmentId - The ID of the assessment to load.
     * @returns A promise that resolves when the assessment is loaded.
     */
    loadAssessment(assessmentId: number): Promise<void>;
}
